import React from 'react';
import { Modal, Button } from 'react-bootstrap'; // Assuming you're using react-bootstrap

const QuantityPopupinfo = ({ show, onHide, title, message }) => {
    return (
        <Modal show={show} onHide={onHide}>
            <Modal.Header closeButton>
                <Modal.Title>{title}</Modal.Title>
            </Modal.Header>
            <Modal.Body>{message}</Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onHide}>
                    Close
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default QuantityPopupinfo;